export default __webpack_public_path__ + "static/Mosasaur_Tek_Saddle-630e7b824b958ec2786793e75e5940f6.png";